import { ExternalLink } from "lucide-react";

interface CardBlockProps {
  url: string;
  title: string;
  description?: string;
  image?: string;
  siteName?: string;
}

function getFaviconUrl(url: string): string {
  try {
    const host = new URL(url).hostname;
    return `https://www.google.com/s2/favicons?domain=${host}&sz=16`;
  } catch {
    return "";
  }
}

function getHostname(url: string): string {
  try {
    return new URL(url).hostname;
  } catch {
    return url;
  }
}

export function CardBlock({ url, title, description, image, siteName }: CardBlockProps) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="my-2 flex overflow-hidden rounded-lg border border-border hover:bg-accent/50 transition-colors group"
    >
      {image && (
        <div className="hidden sm:block w-32 shrink-0 overflow-hidden bg-muted">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={image}
            alt=""
            className="h-full w-full object-cover"
            loading="lazy"
          />
        </div>
      )}
      <div className="min-w-0 flex-1 p-3">
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={getFaviconUrl(url)}
            alt=""
            className="h-3.5 w-3.5 rounded-sm"
            loading="lazy"
          />
          <span>{siteName || getHostname(url)}</span>
        </div>
        <p className="mt-1 text-sm font-medium text-primary group-hover:underline line-clamp-2">
          {title}
        </p>
        {description && (
          <p className="mt-0.5 text-xs text-muted-foreground line-clamp-2">
            {description}
          </p>
        )}
      </div>
      <ExternalLink className="m-3 h-3.5 w-3.5 shrink-0 text-muted-foreground opacity-0 group-hover:opacity-100" />
    </a>
  );
}
